import { Icon } from "@rmwc/icon"
import "@rmwc/icon/styles"

const IconComponent = <Icon icon="thumb_down" />

export const ThumbDownIcon = IconComponent
